module.exports = __webpack_public_path__ + "static/media/crayola-signature.d07d1c3d.png";